import type { SVGProps } from 'react';

export const ArrowTurnDownRightSFSymbolMedium = (
  props: SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 18.8021 16.4723"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="16.4723" opacity="0" width="18.8021" x="0" y="0" />{' '}
        <path
          d="M16.2926 8.02578L12.3158 11.6061L10.1443 13.8078C9.95118 14.0072 9.83614 14.2705 9.83614 14.5734C9.83614 15.1619 10.2758 15.5943 10.8889 15.5943C11.1557 15.5943 11.4197 15.4836 11.6662 15.2434L18.0906 8.8287C18.3203 8.60702 18.4408 8.32089 18.4408 8.02578C18.4408 7.73867 18.3203 7.44278 18.0906 7.23086L11.6502 0.792189C11.4197 0.569729 11.1557 0.466996 10.8889 0.466996C10.2758 0.466996 9.83614 0.899414 9.83614 1.48789C9.83614 1.79081 9.95919 2.05234 10.1443 2.2455L12.3158 4.44374ZM16.325 7.11075L12.9299 6.95977L6.56211 6.95977C3.31386 6.95977 2.1578 5.62754 2.1578 2.34549C2.1658 1.83046 2.18612 1.40312 2.19412 1.05097C2.19412 0.425388 1.76151 0 1.1412 0C0.475973 0 0.183593 0.477924 0.0984371 0.947647C0.021289 1.34003 0 1.83963 0 2.41405C0 7.01405 1.90684 9.09804 6.42676 9.09804L12.9299 9.09804L16.317 8.95507C16.8264 8.93554 17.2383 8.53515 17.2383 8.02578C17.2383 7.53067 16.8344 7.13204 16.325 7.11075Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
